import {
  TDiscountTableData,
  TServiceTableData,
} from 'modules/accommodations/features/reservations/models';

export const checkPropertyIsObjectDefinedServicesAndDiscounts = (
  servicesTableData: TServiceTableData[],
  discountsTableData: TDiscountTableData[],
) => {
  const isObjectsDefinedFalseServices = servicesTableData.some(
    (item: TServiceTableData) => !item.objectDefined,
  );
  const isObjectsDefinedFalseDiscounts = discountsTableData.some(
    (item: TDiscountTableData) => !item.objectDefined,
  );

  const showCalculatedAmounts = isObjectsDefinedFalseServices || isObjectsDefinedFalseDiscounts;

  return showCalculatedAmounts;
};
